import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router, ActivatedRoute, Data } from '@angular/router';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { OrcStatus } from '../models/orc-status';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { OrcStatusService } from '../services/orc-status.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-orc-status',
  templateUrl: './orc-status.component.html',
  styleUrls: ['./orc-status.component.scss']
})
export class OrcStatusComponent implements OnInit {

  // variáveis
  orcsStatus: OrcStatus[] = [];
  orcsStatusFiltrados: OrcStatus[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  tipo = 0;
  texto = 'Orçamento';

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  // construtor
  constructor(private orcStatusService: OrcStatusService, private utilitarioService: UtilitarioService,
    private router: Router, private paginatorService: PaginatorService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private route: ActivatedRoute) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.route.data.subscribe((data: Data) => {
      this.tipo = data['tipo'];
      this.texto = this.tipo === 0 ? 'Orçamento' : 'Repasse';
      this.buscarStatusOrcamento();
    });    
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.orcsStatus = this.orcsStatus.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        switch (this.campoOrdenacao) {
        case 'nome': return this.compare(a.descricao, b.descricao, isAsc);
        default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.orcsStatusFiltrados = this.orcsStatus.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase()));

    if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
      this.itensPorPagina = 10;
    }

    this.paginacao.total = this.orcsStatusFiltrados.length;
    this.paginator.firstPage();
    this.mudaDePagina({ length: this.orcsStatus.length, pageIndex: 0, pageSize: this.itensPorPagina });
  }

  buscarStatusOrcamento() {
    this.carregandoService.mostra('buscarStatusOrcamento');
    this.carregando = true;

    this.orcStatusService.consultar(this.tipo).subscribe((data: any) => {
      this.paginator.firstPage();
      this.orcsStatus = data;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = this.orcsStatus.length;

      this.mudaDePagina({ length: this.orcsStatus.length, pageIndex: 0, pageSize: this.itensPorPagina });

      this.carregando = false;
      this.carregandoService.esconde('buscarStatusOrcamento');

    }, (erro) => {
      this.carregandoService.esconde('buscarStatusOrcamento');
      this.notificacaoService.erro(erro);
    });
  }

  novoOrcStatus() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarOrcStatus(orcStatus: OrcStatus) {
    this.router.navigate(['editar', orcStatus.id], { relativeTo: this.route });
  }

  excluirOrcStatus(orcStatus: OrcStatus) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Status de ' + this.texto + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiOrcStatus');
        this.orcStatusService.excluir(orcStatus.id).subscribe(resp => {
          this.notificacaoService.sucesso('Status de ' + this.texto + ' excluído com sucesso!!!');
          this.carregandoService.esconde('excluiOrcStatus');
          this.buscarStatusOrcamento();
        }, (erro) => {
          this.carregandoService.esconde('excluiOrcStatus');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.orcsStatusFiltrados = this.orcsStatus.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase())).
      slice(pageEvent.pageIndex * pageEvent.pageSize,
        (pageEvent.pageIndex * pageEvent.pageSize) + pageEvent.pageSize);
  }

  ngOnDestroy(): void { }
}